export const throttleCallback = <Arg>(callback: (arg: Arg[]) => void, timeoutMs: number) => {
  let args: Arg[] = []

  setInterval(() => {
    if (args.length === 0) {
      return
    }
    callback(args)
    args = []
  }, timeoutMs)

  const wrapper = (arg: Arg) => {
    args.push(arg)
  }

  return wrapper
}

export function debounce<T extends unknown[]>(callback: (...args: T) => void, timeMs: number) {
  let timeoutId: number | undefined

  return (...params: T) => {
    if (timeoutId) window.clearTimeout(timeoutId)

    timeoutId = window.setTimeout(() => {
      callback(...params)
    }, timeMs)
  }
}

export function stub(...args: unknown[]): void {
  console.debug('Вызвана функция заглушка', args)
}
